import { debug, UNHANDLED } from '../../../utils';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';

const log = debug('lego:models/Location');
import { Coord } from './mapUtils';
const DEFAULT_POSITION = new Coord({latitude: 43.0988964, longitude: -87.9046935 });
//const getUserPosition = (userPosition) => new Coord(get(userPosition, 'data') as any || DEFAULT_POSITION);

function getUserPosition(userPosition, mapState={map_location: DEFAULT_POSITION}) {
 return new Coord(get(userPosition, 'data', mapState.map_location))
}

const getCenter = (mapState, userPosition) => {
 const { map_controlled, map_location } = mapState
 const detectedCenter = map_controlled ? map_location : getUserPosition(userPosition, mapState)
 return new Coord(detectedCenter)
}

const getLatLng = (query) => {
    if (isEmpty(query)) return undefined;
    const {latitude, longitude} = new Coord(query);
    return {lat: latitude, lng: longitude};
};

const positionToLatLngObj = ({latitude, longitude}) => ({lat: latitude, lng: longitude});

import { locate } from './actions';
const findLocation = locate;
//const findLocation = locate.start;

import { Bounds, getZoomLevelForBounds } from '../../models/Location/mapUtils';
const fitPoints = (points, setLocation) => {
  const new_bounds = Bounds.fromPoints(points);
	const { latitude, longitude } = new_bounds.center();
	const zoom = getZoomLevelForBounds(new_bounds, {
		width: document.body.offsetWidth, height: document.body.offsetHeight
	});
  setLocation({latitude, longitude, zoom});
}

const pointsInBounds = (points, map) => {
	if (!map) return true
  const mapBounds = new Bounds(map.getBounds());
	return points.map(point => new Coord(point)).filter(point => mapBounds.contains(point))
};

import every from 'lodash/every';
const allPointsInBounds = (points, map) => {
	if (!map) return true
  const mapBounds = new Bounds(map.getBounds());
  return (!every(points, (point: any) => mapBounds.contains(new Coord(point))));
};

export { findLocation, getCenter, DEFAULT_POSITION, getUserPosition, positionToLatLngObj, getLatLng,
         fitPoints, allPointsInBounds, pointsInBounds };

//const center = [DEFAULT_CENTER, state.mapState.map_controlled ? state.mapState.map_location : state.userPosition.data]
// [ownProps.location.query]
// 		.map(getLatLng)
// 		.reduce((a, b) => m(a, b, (a, b) => (b||a))),

// import mergeWith from 'lodash/mergeWith';
// const m = mergeWith;
// const userPositionFromState = (state) => new Coord([
//     //def -> IP -> stored -> watchLocation
// ]);
// const centerFromState = (state) => new Coord([
//     DEFAULT_POSITION, state.mapState.map_controlled ? state.mapState.map_location : state.userPosition.data
// ].map(getLatLng)
//  .reduce((a, b) => m(a, b, (a, b) => (b||a))));



// WEBPACK FOOTER //
// ./src/app/models/Location/index.ts